import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Container, Jumbo } from '@treams/treams-ui';

import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';
import GoalsTabs from '../GoalsTabs';

import CollectiveGoalsV2 from './CollectiveGoalsV2';
import { CollectiveGoalsList } from './Common';

const Background = styled(Container)`
	background: ${(props) => props.theme.colors.whiteBlue};
`;

export default function CollectiveGoals() {
	const { t } = useTranslation();
	const hasParentDepartmentGoals = useFeature('2023.goals.parentDepartmentGoals');

	if (hasParentDepartmentGoals) {
		return <CollectiveGoalsV2 />;
	}

	return (
		<>
			<Jumbo
				title={t('goals.index.title')}
				description={t('goals.index.description')}
				footer={<GoalsTabs />}
			/>
			<Background py={4} minHeight="100vh">
				<CollectiveGoalsList />
			</Background>
		</>
	);
}
